const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class SamplesCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (!this?.externalEls?.scrollto?.exists) return

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(
      this.externalEls.scrollto.element,
      'click',
      this.handleClick,
    )
  }

  handleClick () {
    this.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 2.2,
          spacing: 5,
          origin: 'center',
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 4.2,
              spacing: 5,
              origin: 'center',
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 5.2,
              spacing: 5,
              origin: 'center',
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 6.2,
              spacing: 5,
              origin: 'center',
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('samples-carousel')) {
  customElements.define('samples-carousel', SamplesCarousel)
}
